"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserRoleEnum = exports.AuthProviderEnum = void 0;
var AuthProviderEnum;
(function (AuthProviderEnum) {
    AuthProviderEnum["GOOGLE"] = "google";
    AuthProviderEnum["GITHUB"] = "github";
})(AuthProviderEnum = exports.AuthProviderEnum || (exports.AuthProviderEnum = {}));
var UserRoleEnum;
(function (UserRoleEnum) {
    UserRoleEnum["USER"] = "user";
})(UserRoleEnum = exports.UserRoleEnum || (exports.UserRoleEnum = {}));
